import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Popup,
} from 'semantic-ui-react';

import {
  getFollowingPromise,
  addFollowingPromise,
  removeFollowingPromise,
} from '../../actions/promises';

export const FollowingBtnGuide = () => (
  <Popup
    content="登入來使用追蹤功能"
    trigger={(
      <Button
        color="red"
        content="追蹤"
        icon="heart"
        labelPosition="left"
        size="tiny"
      />
    )}
  />
);

class FollowingBtn extends Component {
  state = {
    isFollowing: null,
    isFetching: false,
  }

  componentDidMount() {
    const {
      id,
      platform,
      type,
    } = this.props;

    this.setState({
      isFetching: true,
    });

    getFollowingPromise(platform, type, id)
      .then((res) => this.setState({
        isFollowing: Boolean(res.data),
        isFetching: false,
      }))
      .catch(() => {
        this.setState({
          isFetching: false,
        });
      });
  }

  handleOnClick = () => {
    const {
      id,
      platform,
      type,
    } = this.props;
    const {
      isFollowing,
    } = this.state;
    const promise = isFollowing ? removeFollowingPromise : addFollowingPromise;

    this.setState({
      isFetching: true,
    });

    promise(platform, type, id)
      .then(() => this.setState({
        isFollowing: !isFollowing,
        isFetching: false,
      }))
      .catch(() => {
        this.setState({
          isFetching: false,
        });
      });
  }

  render() {
    const {
      isFollowing,
      isFetching,
    } = this.state;

    const { isMobile } = this.props;

    return isMobile ? (
      <Button
        size="tiny"
        disabled={isFollowing === null}
        icon={
          isFollowing
            ? 'heart outline' : 'heart'
        }
        color={
          isFollowing
            ? 'yellow' : 'red'
        }
        loading={isFetching}
        onClick={this.handleOnClick}
      />
    ) : (
      <Button
        size="tiny"
        disabled={isFollowing === null}
        content={
          isFollowing
            ? '放棄追蹤' : '追蹤'
        }
        icon={
          isFollowing
            ? 'heart outline' : 'heart'
        }
        labelPosition="left"
        color={
          isFollowing
            ? 'yellow' : 'red'
        }
        loading={isFetching}
        onClick={this.handleOnClick}
      />
    );
  }
}

const mapStateToProps = (state) => ({
  isMobile: state.browser.lessThan.medium,
});

export default connect(mapStateToProps)(FollowingBtn);
